module.exports = __webpack_public_path__ + "img/pic-03.3cd1afec.png";